var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-container",on:{"click":_vm.toggleClick}},[_c('svg-icon',{attrs:{"icon-class":"cart"}}),(_vm.badge > 0)?_c('div',{staticClass:"badge-container"},[_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.badge))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }